import { render, staticRenderFns } from "./sentence_practice.vue?vue&type=template&id=20ebc1d2&scoped=true"
import script from "./sentence_practice.vue?vue&type=script&lang=js"
export * from "./sentence_practice.vue?vue&type=script&lang=js"
import style0 from "./sentence_practice.vue?vue&type=style&index=0&id=20ebc1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ebc1d2",
  null
  
)

export default component.exports